import React from 'react';
import PropTypes from 'prop-types';
import { HeroPropType } from '@/components/HeaderHero/util/heroPropType';
import VideoHero from './Video/VideoHero';
import { Image as ImageHero } from './Image';
import headerHeroType from './util/headerHeroType';
import { StatementHero } from './Statement';
import { Teaser } from './Teaser';
import { Slider } from './Slider';

import * as S from './styled';

export const HeaderHero = ({ header }) => {
  let renderedHero = null;
  switch (headerHeroType(header ?? {})) {
    case 'video_teaser':
      renderedHero = <VideoHero data={header?.hero[0]} />;
      break;
    case 'teaser':
      renderedHero = <Teaser data={header?.hero[0]} />;
      break;
    case 'statement':
      renderedHero = <StatementHero data={header?.hero[0]} />;
      break;
    case 'video':
      renderedHero = <VideoHero data={header?.hero[0]} />;
      break;
    case 'image':
      renderedHero = (
        <ImageHero
          backgroundImageUrl={header?.hero[0].imageUrl}
          altText={header?.hero[0].altText}
        />
      );
      break;
    case 'slider':
      renderedHero = <Slider items={header?.hero} />; // Slider can't be a child of a parent Slider.
      break;
    default:
      return null;
  }

  return <S.HeroContainer>{renderedHero}</S.HeroContainer>;
};

HeaderHero.propTypes = {
  header: PropTypes.shape({
    hero: PropTypes.arrayOf(HeroPropType),
  }),
};
